// Exercise player and exercise page labels.
export const PLAYER_STRINGS = {
  en: {
    p_contract: "Contract", p_relax: "Relax", p_inhale: "Inhale", p_hold: "Hold", p_exhale: "Exhale", p_ready: "Ready", p_done: "Well done",
    p_seconds: "{n} seconds", p_rep: "Repetition {n} of {t}", p_cycle: "Cycle {n} of {t}", p_step: "Step {n} of {t}",
    p_start: "Start", p_pause: "Pause", p_resume: "Resume", p_stop: "Stop", p_complete: "Complete", p_autoplay: "Auto-play",
    p_g1: "Breathe normally", p_g2: "Avoid squeezing your abdomen excessively", p_g3: "Avoid unnecessary straining", p_g4: "Stop if pain occurs",
    instructions: "Instructions", safety: "Safety",
  },
  hi: {
    p_contract: "सिकोड़ें", p_relax: "ढीला छोड़ें", p_inhale: "साँस लें", p_hold: "रोकें", p_exhale: "साँस छोड़ें", p_ready: "तैयार", p_done: "बहुत बढ़िया",
    p_seconds: "{n} सेकंड", p_rep: "दोहराव {n} / {t}", p_cycle: "चक्र {n} / {t}", p_step: "चरण {n} / {t}",
    p_start: "शुरू करें", p_pause: "रोकें", p_resume: "फिर से शुरू करें", p_stop: "बंद करें", p_complete: "पूरा हुआ", p_autoplay: "अपने-आप चलाएँ",
    p_g1: "सामान्य रूप से साँस लेते रहें", p_g2: "पेट को ज़रूरत से ज़्यादा न दबाएँ", p_g3: "बेवजह ज़ोर न लगाएँ", p_g4: "दर्द हो तो तुरंत रुक जाएँ",
    instructions: "निर्देश", safety: "सुरक्षा",
  },
  hinglish: {
    p_contract: "Contract karo", p_relax: "Relax karo", p_inhale: "Saans lo", p_hold: "Roko", p_exhale: "Saans chhodo", p_ready: "Ready", p_done: "Bahut badhiya",
    p_seconds: "{n} second", p_rep: "Repetition {n} / {t}", p_cycle: "Cycle {n} / {t}", p_step: "Step {n} / {t}",
    p_start: "Start", p_pause: "Pause", p_resume: "Resume", p_stop: "Stop", p_complete: "Complete", p_autoplay: "Auto-play",
    p_g1: "Normal saans lete raho", p_g2: "Pet ko zyada mat dabao", p_g3: "Bina wajah zor mat lagao", p_g4: "Dard ho toh turant ruk jao",
    instructions: "Instructions", safety: "Safety",
  },
};
